import * as React from "react";
import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  Container,
  Avatar,
  Tooltip,
  MenuItem,
  Button,
} from "@mui/material";

import AdbIcon from "@mui/icons-material/Adb";
import MenuIcon from "@mui/icons-material/Menu";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";

import Role from "../../policies/Role";
import PoliciesHelper from "../../policies/PoliciesHelper";
import { Link, useLocation } from "react-router-dom";
import AssignBadgeButton from "../Dashboard/AssignBadgeButton";
import { AuthContext } from "../../context/AuthContext";
import axios from "../../utils/Api";

class NavbarContent extends React.Component {
  static contextType = AuthContext;

  constructor(props) {
    super(props);

    this.state = {
      anchorElNav: null,
      anchorElUser: null,
      pages: [],
      role: null,
      username: "",
      globalFeedEnabled: false, // ← inconnu au départ, sera fetch
      userSettings: [
        { name: "Mon profil", href: "/profile" },
        { name: "Paramètres", href: "/modify-profile" },
        { name: "Se déconnecter", href: "/auth/logout" },
      ],
      initials: "ND",
    };
  }

  componentDidMount() {
    const { user } = this.context;
    this.refreshUserData(user);

    // Charger le statut global du fil pour afficher/masquer l'onglet Actualités
    axios.get("/settings/feed")
      .then((res) => {
        const enabled = !!res.data.enabled;
        this.setState(
          { globalFeedEnabled: enabled },
          () => this.refreshUserData(this.context.user)
        );
      })
      .catch(() => {
        this.setState({ globalFeedEnabled: false });
      });
  }

  componentDidUpdate() {
    const { user } = this.context;

    if (
      user?.role !== this.state.role ||
      user?.username !== this.state.username
    ) {
      this.refreshUserData(user);
    }
  }

getPagesForRole = (role) => {
  const helper = new PoliciesHelper(role);

  const isAdmin = role === Role.Admin || role === Role.AdminContact;
  const isTeacher = role === Role.Teacher;
  const isStudent = role === Role.User;

  const { globalFeedEnabled } = this.state;

  const pages = [];

  if (isAdmin) {
    pages.push({
      name: "Administration",
      href: "/admin",
      minimumRole: Role.Admin,
      isSpecialAdminButton: true,
    });
  }
  else if (isTeacher || isStudent) {
  pages.push({
    name: "Accueil",
    href: "/",
    minimumRole: Role.User,
  });
  }

  if ((isTeacher && globalFeedEnabled) || isAdmin) {
    pages.push({
      name: "Actualités",
      href: "/feed",
      minimumRole: Role.User,
    });
  }

  pages.push(
    { name: "Mon profil", href: "/profile", minimumRole: Role.User },
    { name: "Classement", href: "/leaderboard", minimumRole: Role.User },
    { name: "Liste des badges", href: "/badges", minimumRole: Role.User }
  );

  return helper.getvisibleRoutes(pages);
};

  refreshUserData = (user) => {
    this.setState({
      role:     user?.role     ?? null,
      username: user?.username ?? "",
      pages:    this.getPagesForRole(user?.role),
      initials: this.getInitials(user?.username ?? "na"),
    });
  };

  handleOpenNavMenu  = (e) => this.setState({ anchorElNav: e.currentTarget });
  handleOpenUserMenu = (e) => this.setState({ anchorElUser: e.currentTarget });
  handleCloseNavMenu  = () => this.setState({ anchorElNav: null });
  handleCloseUserMenu = () => this.setState({ anchorElUser: null });

  getInitials = (name) => {
    let initials = name.match(/\b\w/g) || [];
    initials = ((initials.shift() || "") + (initials.pop() || "")).toUpperCase();
    return initials || "ND";
  };

  render() {
    const { user } = this.context;
    const isConnected = Boolean(user);
    const location    = this.props.location;
    const isAdminPage = location?.pathname?.startsWith("/admin");

    return (
      <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          background: "linear-gradient(90deg, #1976d2, #1565c0)",
          boxShadow: "0 4px 18px rgba(0, 0, 0, 0.18)",
        }}
      >
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <AdbIcon sx={{ display: { xs: "none", md: "flex" }, mr: 1 }} />

            <Typography
              variant="h6" noWrap component={Link} to="/"
              sx={{
                mr: 3, display: { xs: "none", md: "flex" },
                fontFamily: "monospace", fontWeight: 700,
                letterSpacing: ".25rem", color: "white", textDecoration: "none",
              }}
            >
              E-BADGE
            </Typography>

            {/* Menu mobile */}
            <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
              <IconButton
                size="large" aria-label="menu principal"
                aria-controls="menu-appbar" aria-haspopup="true"
                onClick={this.handleOpenNavMenu} color="inherit"
              >
                <MenuIcon />
              </IconButton>

              <Menu
                id="menu-appbar" anchorEl={this.state.anchorElNav}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                keepMounted
                transformOrigin={{ vertical: "top", horizontal: "left" }}
                open={Boolean(this.state.anchorElNav)}
                onClose={this.handleCloseNavMenu}
                sx={{ display: { xs: "block", md: "none" } }}
              >
                {this.state.pages.map((page) => (
                  <MenuItem
                    key={page.href} component={Link} to={page.href}
                    onClick={this.handleCloseNavMenu}
                    sx={page.isSpecialAdminButton ? {
                      backgroundColor: "rgba(25,118,210,0.08)",
                      color: "#1565c0", fontWeight: 700,
                      borderLeft: "4px solid #1976d2",
                      "&:hover": { backgroundColor: "rgba(25,118,210,0.16)" },
                    } : {}}
                  >
                    {page.isSpecialAdminButton && (
                      <AdminPanelSettingsIcon sx={{ mr: 1, fontSize: 20 }} />
                    )}
                    <Typography textAlign="center"
                      sx={{ fontWeight: page.isSpecialAdminButton ? 700 : 400 }}
                    >
                      {page.name}
                    </Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>

            <AdbIcon sx={{ display: { xs: "flex", md: "none" }, mr: 1 }} />

            <Typography
              variant="h5" noWrap component={Link} to="/"
              sx={{
                mr: 2, display: { xs: "flex", md: "none" }, flexGrow: 1,
                fontFamily: "monospace", fontWeight: 700,
                letterSpacing: ".2rem", color: "white", textDecoration: "none",
              }}
            >
              E-BADGE
            </Typography>

            {/* Menu ordinateur */}
            <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" }, alignItems: "center" }}>
              {this.state.pages.map((page) => (
                <Button
                  component={Link} to={page.href} key={page.href}
                  onClick={this.handleCloseNavMenu}
                  startIcon={page.isSpecialAdminButton ? <AdminPanelSettingsIcon /> : null}
                  sx={page.isSpecialAdminButton ? {
                    my: 2, mx: 0.8, px: 2.2, py: 0.8,
                    color: "#1565c0", backgroundColor: "white",
                    borderRadius: "999px", textTransform: "none",
                    fontWeight: 800, letterSpacing: "0.2px",
                    border: "2px solid rgba(255,255,255,0.9)",
                    boxShadow: "0 4px 14px rgba(255,255,255,0.25)",
                    transition: "0.22s ease",
                    "&:hover": {
                      backgroundColor: "#e3f2fd", color: "#0d47a1",
                      transform: "translateY(-2px)",
                      boxShadow: "0 6px 18px rgba(255,255,255,0.35)",
                    },
                  } : {
                    my: 2, mx: 0.4, px: 1.6,
                    color: "white", display: "block",
                    borderRadius: "10px", textTransform: "none",
                    fontWeight: 600, transition: "0.2s ease",
                    "&:hover": { backgroundColor: "rgba(255,255,255,0.16)" },
                  }}
                >
                  {page.name}
                </Button>
              ))}
            </Box>

            {/* Section droite */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {!isAdminPage && <AssignBadgeButton sx={{ mr: 2 }} />}

              {isConnected && (
                <>
                  <Tooltip title="Mon compte">
                    <IconButton
                      size="large" onClick={this.handleOpenUserMenu}
                      aria-label="compte utilisateur"
                      aria-controls="menu-user" aria-haspopup="true"
                      color="inherit"
                    >
                      <Avatar sx={{ bgcolor: "white", color: "primary.main", fontWeight: 700 }}>
                        {this.state.initials}
                      </Avatar>
                    </IconButton>
                  </Tooltip>

                  <Menu
                    sx={{ mt: "45px" }} id="menu-user"
                    anchorEl={this.state.anchorElUser}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    keepMounted
                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                    open={Boolean(this.state.anchorElUser)}
                    onClose={this.handleCloseUserMenu}
                  >
                    {this.state.userSettings.map((setting) => (
                      <MenuItem
                        key={setting.name} component={Link} to={setting.href}
                        onClick={this.handleCloseUserMenu}
                      >
                        <Typography textAlign="center">{setting.name}</Typography>
                      </MenuItem>
                    ))}
                  </Menu>
                </>
              )}
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    );
  }
}

export default function Navbar(props) {
  const location = useLocation();
  return <NavbarContent {...props} location={location} />;
}
